import Vue from "vue";
import service from "@/libs/service";

export const namespaced = true;

export const state = {
    organizations: [],
    count: 0,
    currentPage: 1,
    pageSize: parseInt(process.env.VUE_APP_DASHBOARD_ORGANIZATIONS_PAGE_SIZE),
    maxPages: parseInt(process.env.VUE_APP_DASHBOARD_ORGANIZATIONS_MAX_PAGES),
};

export const mutations = {
    SET_ORGANIZATIONS: (state, organizations) => 
        Vue.set(state, "organizations", [...organizations]),
    SET_COUNT: (state, count) => 
        Vue.set(state, "count", count),
    SET_CURRENT_PAGE: (state, currentPage) => 
        Vue.set(state, "currentPage", currentPage),
};

export const actions = {
    async getOrganizations({ commit, state }, params) {
        commit("SET_ORGANIZATIONS", []);

        let content = {
            limit: state.pageSize,
            offset: (params.page - 1) * state.pageSize,
        };
        commit("SET_CURRENT_PAGE", params.page);

        try {
            let { count, rows } = await service.request("/organizations/list", params.role === "sysadmin" ? { ...params, role: "sysadmin" } : content);
            commit("SET_COUNT", count);
            commit("SET_ORGANIZATIONS", rows);
            if (params.role === "sysadmin") {
                return {
                    organizations: rows,
                    total: count
                };
            }
            return response;
        } catch (error) {
            return error;
        }
    },
    async searchOrganizations({ commit, state }, { tags, page }) {
        let name = tags ?  `name=${ tags.join(",") }` : "";
        let limit = `&limit=${state.pageSize}`;
        let offset = page ? `&offset=${ state.pageSize * (page - 1) }` : "";
        let serviceUrl = `/search/organizations?${ name }${ limit }${ offset }`;

        try {
            let { count, organizations } = await service.request(serviceUrl);
            if (count > 0) {
                commit("SET_COUNT", count);
                commit("SET_ORGANIZATIONS", organizations);
            }

            return { count, organizations };
        } catch (error) {
            return error;
        }
    }
};

export const getters = {
    organizations(state) {
        return state.organizations.sort((a, b) => {
            return (b.weight - a.weight);
        });
    },
    pagination({ count, pageSize, maxPages, currentPage }) {
        let totalPages = Math.ceil(count / pageSize);
        let length = Math.min(totalPages, maxPages);
        let disabled = count <= pageSize;

        return {
            current: currentPage,
            length,
            disabled,
        };
    }
};
